import { render, staticRenderFns } from "./ButtonForm.vue?vue&type=template&id=1563bb0a"
import script from "./ButtonForm.vue?vue&type=script&lang=js"
export * from "./ButtonForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1563bb0a')) {
      api.createRecord('1563bb0a', component.options)
    } else {
      api.reload('1563bb0a', component.options)
    }
    module.hot.accept("./ButtonForm.vue?vue&type=template&id=1563bb0a", function () {
      api.rerender('1563bb0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/flowable/extension/ButtonForm.vue"
export default component.exports